import { useState } from "react";
import ImageViewer from "components/common/ImageViewer";

export default function MediaSection({
  data,
  errors,
  onFileChange,
  existingLogo,
  existingBanner,
}) {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerSrc, setViewerSrc] = useState(null);

  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium">
          Banner Image<span className="text-red-500">*</span>
          <span className="ml-2 text-xs font-normal text-gray-500">
            (Recommended resolution: <b>393 × 219 px</b>. Accepted formats: JPEG, PNG. )
          </span>
        </label>

        {existingBanner && (
          <img
            src={existingBanner}
            alt="Banner"
            className="mb-3 h-24 rounded-lg border object-cover cursor-pointer"
            onClick={() => {
              setViewerSrc(existingBanner);
              setViewerOpen(true);
            }}
          />
        )}

        <input
          type="file"
          name="bannerImage"
          onChange={onFileChange}
          className="w-full rounded-xl border p-3"
        />

        {errors.bannerImage && (
          <p className="mt-1 text-xs text-red-500">
            {errors.bannerImage}
          </p>
        )}
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium">
          Logo Image<span className="text-red-500 ml-1">*</span>
          <span className="ml-2 text-xs font-normal text-gray-500">
              (Recommended resolution: <b>120 × 40 px</b>. Accepted formats: JPEG, PNG. )
          </span>
        </label>

        {existingLogo && (
          <img
            src={existingLogo}
            alt="Logo"
            className="mb-3 h-24 rounded-lg border object-contain cursor-pointer"
            onClick={() => {
              setViewerSrc(existingLogo);
              setViewerOpen(true);
            }}
          />
        )}

        <input
          type="file"
          name="logoImage"
          onChange={onFileChange}
          className="w-full rounded-xl border p-3"
        />

        {errors.logoImage && (
          <p className="mt-1 text-xs text-red-500">
            {errors.logoImage}
          </p>
        )}
      </div>

      <ImageViewer
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        src={viewerSrc}
      />
    </>
  );
}
